import { useState, useEffect, useCallback } from 'react';
import { getTheme, applyTheme } from '../lib/theme';
import api from '../lib/api';

export function useTheme() {
  const [theme, setThemeState] = useState(getTheme);
  useEffect(() => {
    const h = (e) => setThemeState(e.detail.theme);
    window.addEventListener('nuyed:theme', h);
    return () => window.removeEventListener('nuyed:theme', h);
  }, []);
  const setTheme = useCallback((t) => {
    const applied = applyTheme(t);
    let authed = false;
    try { authed = !!localStorage.getItem('nuyed_token'); } catch {}
    if (authed) api.put('/users/me', { theme: applied }).catch(() => {});
  }, []);
  const toggle = useCallback(() => setTheme(getTheme() === 'dark' ? 'light' : 'dark'), [setTheme]);
  return { theme, setTheme, toggle, isDark: theme === 'dark' };
}
